import { render, staticRenderFns } from "./StripeButton.vue?vue&type=template&id=6df6c7e6"
import script from "./StripeButton.vue?vue&type=script&lang=js"
export * from "./StripeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports